<!--  -->
<template>
  <div id="footer">
    <van-tabbar
      v-model="internalActive"
      fixed
      route
      active-color="#b19c4a"
      inactive-color="#555555"
    >
      <van-tabbar-item
        replace
        to="/home"
        name="dwdj"
      >
        <span>党务党建</span>
        <template #icon="props">
          <img :src="props.active ? icon.active : icon.inactive" />
        </template>
      </van-tabbar-item>

      <van-tabbar-item
        replace
        to="/peopleList"
        name="dyrj"
      >
        <span>党员之家</span>
        <template #icon="props">
          <img :src="props.active ? icon.activeDy : icon.inactiveDy" />
        </template>
      </van-tabbar-item>

      <van-tabbar-item
        replace
        to="/chat"
        name="lttz"
      >
        <span>驾驶舱</span>
        <template #icon="props">
          <img :src="props.active ? icon.activeChat : icon.inactiveChat" />
        </template>
      </van-tabbar-item>

      <van-tabbar-item
        replace
        to="/PersonalCenter"
        name="grzx"
      >
        <span>个人中心</span>
        <template #icon="props">
          <img :src="props.active ? icon.activePer : icon.inactivePer" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import dwActive from '../assets/images/normal_u55.svg'
import dwUnActive from '../assets/images/normal_u73.svg'
import dyActive from '../assets/images/normal_u75.svg'
import dyUnActive from '../assets/images/normal_u69.svg'
import tz from '../assets/images/tz.svg'
import tzActive from '../assets/images/tzActive.svg'
import person from '../assets/images/person.svg'
import personActive from '../assets/images/personActive.svg'


export default {
  props: {
    active: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      internalActive: this.active,
      icon: {
        active: dyUnActive,
        inactive: dwUnActive,
        activeDy: dwActive,
        inactiveDy: dyActive,
        activeChat: tzActive,
        inactiveChat: tz,
        activePer: person,
        inactivePer: personActive,

      },
    };
  },
  methods: {

  }


}

</script>
<style lang='less' scoped>
#footer {
  position: fixed;
  width: 100%;
  height: 55px;
  bottom: 0;
  left: 0;
  font-size: 12px;
}
</style>